import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconArrowDown = ({ color = 'var(--color-neutral-3)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="6" height="4" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.406664 0C0.0433953 0 -0.138239 0.52071 0.124122 0.828402L2.70737 3.85799C2.86882 4.04734 3.13118 4.04734 3.29263 3.85799L5.87588 0.828402C6.13824 0.52071 5.9566 0 5.59334 0H0.406664Z"
                fill={color} />
        </svg>
    </div>
);

export default IconArrowDown;
